'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_PushNotificationData$$anon$5(evaluator$4) {
  this.Lapp_data_PushNotificationData$$anon$5__f_evaluator$1 = null;
  this.Lapp_data_PushNotificationData$$anon$5__f_evaluator$1 = evaluator$4;
}
export { $c_Lapp_data_PushNotificationData$$anon$5 as $c_Lapp_data_PushNotificationData$$anon$5 };
$c_Lapp_data_PushNotificationData$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_PushNotificationData$$anon$5.prototype.constructor = $c_Lapp_data_PushNotificationData$$anon$5;
/** @constructor */
function $h_Lapp_data_PushNotificationData$$anon$5() {
}
export { $h_Lapp_data_PushNotificationData$$anon$5 as $h_Lapp_data_PushNotificationData$$anon$5 };
$h_Lapp_data_PushNotificationData$$anon$5.prototype = $c_Lapp_data_PushNotificationData$$anon$5.prototype;
$c_Lapp_data_PushNotificationData$$anon$5.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_PushNotificationData$$anon$5.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_PushNotificationData$$anon$5__f_evaluator$1.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_PushNotificationData$$anon$5.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_PushNotificationData$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_PushNotificationData$$anon$5, "app.data.PushNotificationData$$anon$5", ({
  Lapp_data_PushNotificationData$$anon$5: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_PushNotificationData$$anon$5 as $d_Lapp_data_PushNotificationData$$anon$5 };
//# sourceMappingURL=app.data.-Push-Notification-Data$$anon$5.js.map
